export default {
      id: "sandwich-usage",
      viewBox: "0 0 18 14",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#sandwich",
      toString: function () {
        return this.url;
      }
    }